import { getAuth, sendEmailVerification } from '@angular/fire/auth';
import firebase from 'firebase/compat/app';

const firebaseUIConfig = {
    signInSuccessUrl: '/',
    signInFlow: 'popup',
    signInOptions: [
        {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
        },
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
        signInSuccessWithAuthResult: function (authResult: any) {
            const messageElement = document.getElementById('firebaseui-message');

            const { user } = authResult;
            const continueUrl = window.location.origin;

            if (authResult.additionalUserInfo.isNewUser && !user.emailVerified) {
                sendEmailVerification(user, { url: continueUrl })
                    .then(() => {
                        console.log(`Verification email sent successfully to ${user.email}`);
                        getAuth().signOut();
                        messageElement!.textContent =
                            'A verification email has been sent. Please check your email to verify your account.';
                    })
                    .catch((error: any) => {
                        console.warn('Error sending verification email: ' + error.message);
                    });
                return false;
            } else if (!user.emailVerified) {
                // As we introduced the email verification when we already had users,
                // we need to send the verification email to existing users as well.
                // This can be removed later, once all existing users have verified their email,
                // or left as is, if we'd like to send verification e-mail to the non-verified user on every login attempt.
                sendEmailVerification(user, { url: continueUrl })
                    .then(() => {
                        console.log(
                            `User has not verified e-mail (${user.email}), verification e-mail sent, signing out...`,
                        );
                        getAuth().signOut();
                        messageElement!.textContent =
                            'Please verify your email to log in (verification e-mail has been sent).';
                    })
                    .catch((error: any) => {
                        console.warn('Error sending verification email: ' + error.message);
                    });

                return false;
            }

            console.log('User signed in successfully.', authResult);

            return true;
        },
        signInFailure: function (error: any) {
            console.error('Sign in failure', error);
        },
    },
};

export default firebaseUIConfig;
